import { render, staticRenderFns } from "./MainApp.vue?vue&type=template&id=124c7fb4&"
import script from "./MainApp.vue?vue&type=script&lang=js&"
export * from "./MainApp.vue?vue&type=script&lang=js&"
import style0 from "./MainApp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports